import PropTypes from 'prop-types';
import React from 'react';
import { RadioButtonGroupInput as ReactAdminRadioButtonGroupInput, required as requiredFn } from 'react-admin';

export const RadioButtonGroupInput = ({ isRequired, validate, ...props }) => (
  <ReactAdminRadioButtonGroupInput
    {...props}
    validate={isRequired ? requiredFn() : validate}
  />
)

RadioButtonGroupInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  validate: PropTypes.func,
};

RadioButtonGroupInput.defaultProps = {
  sort: false,
  sortable: false,
  alwaysOn: true
};

export default RadioButtonGroupInput;

